/**
 * Quick Deposit Service
 */

define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const user = require('user');
    const server = require('server');
    const config = require('config');
    const { dispatcher } = require('bundle');
    const BaseModel = require('common/base.model');
    const QuickDepositMethodCollection = require('modules/cashier/quick-deposit/quick-deposit.collection');

    module.exports = BaseModel.extend({

        defaults: {
            isQuickDepositAvailable: false,
            isQuickDepositEnabledByIMS: null
        },

        initialize: function() {
            this.methods = new QuickDepositMethodCollection();
        },

        subscribe: function() {
            this.listenTo(core, { 'auth:login': this.updateIsQuickDepositEnabledByIMS });
            this.listenTo(core, {
                'auth:login auth:logout deposit:success': this.setQuickDepositAvailability
            });
        },

        isQuickDepositAvailable: function() {
            return this.get('isQuickDepositAvailable');
        },

        updateIsQuickDepositEnabledByIMS: function() {
            if (this.get('isQuickDepositEnabledByIMS') !== null || !config.get('isQuickDepositEnabled')) {
                return;
            }

            server.send({
                ID: 35853,
                responses: [35854, 35855],
                description: 'Get Quick deposit config'
            }).then(response => {
                const { mode, enabled } = response.data || {};

                this.set('isQuickDepositEnabledByIMS', Boolean(mode === 0 && enabled));
                this.setQuickDepositAvailability();
            }).catch(() => {
                //
            });
        },

        isQuickDepositAvailableByCashierMethods: async function() {
            try {
                await this.methods.fetch({ reset: true });
            } catch {
                //
            }

            return Boolean(this.methods.getMethod()?.get('quickDeposit'));
        },

        setQuickDepositAvailability: async function() {
            let isAvailable = config.get('isQuickDepositEnabled')
                && config.get('quickDepositPage')
                && user.isLoggedIn()
                && this.get('isQuickDepositEnabledByIMS')
                && await this.isQuickDepositAvailableByCashierMethods();

            this.set('isQuickDepositAvailable', Boolean(isAvailable));

            if (dispatcher) {
                dispatcher.dispatch('quickDeposit:setIsAvailable', { isQuickDepositAvailable: Boolean(isAvailable) });
            }
        }
    });
});
